module.exports = __webpack_public_path__ + "img/4-4.28e13ab0.png";